// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import iviewArea from "iview-area";
import element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App";
import router from "./router";
import myFilters from "./myFilters";
import iView from "iview";
import "./theme/index.less";
import "babel-polyfill";
import { userInfo } from "./http";
import { setStore } from "./storage";
Vue.directive("title", {
  componentUpdated: function(el, binding) {
    document.title = el.dataset.title;
  }
});

Vue.config.productionTip = false;
userInfo().then(data => {
  setStore("userInfo", data.data.userInfo);
});
for (let key in myFilters) {
  //一定要放在 new Vue之前 注册全局过滤器
  Vue.filter(key, myFilters[key]);
}

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});
Vue.use(iviewArea);
Vue.use(iView);
Vue.use(element);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js